<template>
  <b-col class="news-content-container">
    <b-row>
      <b-col class="p-0">
        <h2 class="pl-sm-5 pt-4">Phone codes</h2>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="p-0">
        <b-nav tabs class="pl-sm-5 pr-sm-5">
          <b-nav-item :to="{ name: 'addPhoneCode'}" exact>Add</b-nav-item>
          <b-nav-item :to="{ name: 'phoneCodes'}" exact>Phone codes</b-nav-item>
        </b-nav>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
export default {
  name: 'PhoneCodesTabs'
}
</script>



// WEBPACK FOOTER //
// src/components/PhoneCodesTabs.vue